import React from 'react'
import { useFormikContext, useField } from 'formik'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import Dropdown, { OptionsState } from 'particles/Dropdown'
import { useTranslation } from 'react-i18next'
import { fieldIdentifiers } from 'components/Shared/Comment'
import MenuItem from 'particles/MenuItem'

interface ObjectiveSelectorProps {
    options: OptionsState[] | null
    value: number
}

const ObjectiveSelector: React.FC<ObjectiveSelectorProps> = ({ options, value }) => {
    const { setFieldValue } = useFormikContext<any>()
    const [, meta] = useField('objective')
    const isError = meta.touched && Boolean(meta.error)
    const [t] = useTranslation()
    return (
        <CampaignEditorInputFieldContainer>
            <Dropdown
                label={t('campaignEditor.setUpCampaign.enterCampaignGoalHeader')}
                dataTestId="test-campaign-goal-dropdown"
                placeholder={t('placeholderText.clickToSelect')}
                errorMessage={isError ? meta.error : undefined}
                onChange={(value): void => {
                    setFieldValue('objective', value)
                }}
                value={value}
                isRequired
                identifier={fieldIdentifiers.objective}
            >
                {options?.map((option, index) => (
                    <MenuItem.Text
                        key={`search-dropdown-${index}`}
                        data-testid="test-campaign-goal-option"
                        text={option.label}
                        value={option.value}
                        tabIndex={index}
                    />
                ))}
            </Dropdown>
        </CampaignEditorInputFieldContainer>
    )
}
export default ObjectiveSelector
